import { getStatus, OperationOutcomeError, operationOutcomeToString } from '@medplum/core';

export function formatMedplumClientError(err: unknown): string {
  if (err instanceof OperationOutcomeError) {
    return operationOutcomeToString(err.outcome);
  }
  if (err instanceof Error) {
    return err.message;
  }
  return String(err);
}

export function isMedplumHttpStatus(err: unknown, status: number): boolean {
  return err instanceof OperationOutcomeError && getStatus(err.outcome) === status;
}

/** True when an AccessPolicy denied the resource type, so a read-only fallback should be used. */
export function isMedplumForbiddenError(err: unknown): boolean {
  if (isMedplumHttpStatus(err, 403)) return true;
  return formatMedplumClientError(err).toLowerCase().includes('forbidden');
}
